import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { getCart } from "@insite/client-framework/Services/CartService";
import { CartLineCollectionModel, CartLineModel, ProductDto } from "@insite/client-framework/Types/ApiModels";

const cartsUrl = "/api/v1/carts";

export async function addLineCollection(
    cartLines: any,
    toCurrentCart = false,
    showAddToCartPopup?: boolean,
    isEZselectorProduct?: boolean,
    notAllAdded?: boolean,
): Promise<ServiceResult<CartLineCollectionModel>> {
    const cartLineCollection = { cartLines } as CartLineCollectionModel;

    cartLineCollection?.cartLines?.forEach(line => {
        if (!line?.qtyOrdered?.toString) {
            return null;
        }
        const parsedQty = parseFloat(line?.qtyOrdered?.toString());
        line.qtyOrdered = parsedQty > 0 ? parsedQty : 1;
    });

    try {
        const cartLineModel = await post(`${cartsUrl}/current/cartlines/batch`, cartLineCollection);
        return {
            successful: true,
            result: cartLineModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        if (error.status === 403) {
            return {
                successful: false,
                errorMessage: error.errorMessage,
                statusCode: 403,
            };
        }
        if (error.status === 404) {
            return {
                successful: false,
                errorMessage: error.errorMessage,
                statusCode: 404,
            };
        }
        throw error;
    }
}

export function addLineCollectionProducts(
    products: ProductDto[],
    toCurrentCart = false,
    showAddToCartPopup?: boolean,
    isEZselectorProduct?: boolean,
) {
    const productsObj = [];
    for (let i = 0; i < products.length; i++) {
        productsObj.push({ name: products[i].shortDescription });
    }
    if ((window as any).dataLayer && isEZselectorProduct) {
        (window as any).dataLayer.push({
            event: "addAllToCart",
            ecommerce: {
                add: {
                    product: productsObj,
                },
            },
        });
    }

    const cartLineCollection: CartLineModel[] = [];
    products.forEach((product: { id: any; qtyOrdered: any; selectedUnitOfMeasure: any }) => {
        cartLineCollection.push({
            productId: product.id,
            qtyOrdered: product.qtyOrdered,
            unitOfMeasure: product.selectedUnitOfMeasure,
        } as CartLineModel);
    });
    return addLineCollection(cartLineCollection, toCurrentCart, showAddToCartPopup, isEZselectorProduct);
}
